import React, { ReactElement } from 'react';
import { Skeleton, Text } from '@hopskipdrive/react-components';

import { RideOverviewItemContainer } from './RideOverviewItem.styles';

interface RideOverviewItemProps {
  value: string | number | undefined | ReactElement;
  label: string | undefined;
  labelColor?: string | undefined;
  isFetching?: boolean;
  valueClassName?: string;
}

export const RideOverviewItem: React.FC<RideOverviewItemProps> = ({
  value,
  label,
  labelColor,
  isFetching,
  valueClassName,
}) => {
  return (
    <RideOverviewItemContainer>
      {isFetching && <Skeleton variant="text" width={90} height={26} />}
      {!isFetching && <Text className={valueClassName ? valueClassName : 'value'}>{value}</Text>}
      <Text className="label" textColor={labelColor || 'secondaryText'}>
        {label}
      </Text>
    </RideOverviewItemContainer>
  );
};
